import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CompanyCard from "../general/cards/company";
import "./style.scss";
import { RootState } from "../../reducers/store";
import Spinner from "../vapor/spinner";
import ImgSearchPlaceholder from "../../assets/img/bis-search-companies-placeholder.svg";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/pro-light-svg-icons";
import { Button } from "@vapor/react-material";

interface SearchCompaniesComponentProps {
    searchTerm: string;
    setSearchTerm: (value: string) => void;
    onSelect: (value: any) => void;
    expanded?: boolean;
}

const SearchCompaniesComponent = (props: SearchCompaniesComponentProps) => {
    const search = useSelector((state: RootState) => state.search);
    const modebisconfig = useSelector(
        (state: RootState) => state.modebisconfig,
    );
    const companies = search.companies;

    const [copyTerm, setCopyTerm] = useState("");

    useEffect(() => {
        if (companies.isGettingCompanies) {
            setCopyTerm(props.searchTerm);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companies.isGettingCompanies]);

    if (modebisconfig.readOnly) {
        return (
            <div
                className={
                    "searchRoot searchCompanies" +
                    (props.expanded ? " expanded" : "")
                }
            >
                <div className="searchResults">
                    {!companies.isGettingCompanies && !companies.input && (
                        <div
                            className={
                                "noSearchPlaceholder" +
                                (modebisconfig.readOnly ? " disabled" : "")
                            }
                        >
                            <div
                                className={
                                    "noSearchPlaceholder-image" +
                                    (modebisconfig.readOnly ? "-expired" : "")
                                }
                            >
                                <FontAwesomeIcon
                                    icon={["far", "timer"]}
                                    style={{ fontSize: 32, color: "#9da6ad" }}
                                />
                            </div>
                            <div className="noSearchPlaceholder-expiredTitle">
                                <FormattedMessage id="trial.noSearchPlaceholderTitle" />
                            </div>
                            <div className="noSearchPlaceholder-expiredSubtitle">
                                <FormattedMessage id="trial.noSearchPlaceholderSubtitle" />
                            </div>
                            <div className="noSearchPlaceholder-expiredButton">
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        window.open(
                                            "https://www.teamsystem.com/store/business-information/prezzi/",
                                            "_blank",
                                        );
                                    }}
                                >
                                    <FormattedMessage id="trial.button" />
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div
            className={
                "searchRoot searchCompanies" +
                (props.expanded ? " expanded" : "")
            }
        >
            <div className="searchResults">
                {!companies.isGettingCompanies && !companies.input && (
                    <div className="noSearchPlaceholder">
                        <div className="noSearchPlaceholder-image">
                            <img src={ImgSearchPlaceholder} alt="" />
                        </div>
                        <div className="noSearchPlaceholder-title">
                            <FormattedMessage id="general.noSearchPlaceholderTitle" />
                        </div>
                        <div className="noSearchPlaceholder-subtitle">
                            <FormattedMessage id="general.noSearchPlaceholderSubtitle" />
                        </div>
                    </div>
                )}
                {!companies.isGettingCompanies &&
                    companies.input &&
                    companies?.records.length === 0 && (
                        <div className="noSearchPlaceholder noResults">
                            <div className="noSearchPlaceholder-image noResults">
                                <div className="bis-empty-oval">
                                    <FontAwesomeIcon icon={faFolderOpen} />
                                </div>
                            </div>
                            <div className="noSearchPlaceholder-title noResults">
                                <FormattedMessage id="general.noResultsPlaceholderTitle" />
                            </div>
                            <div className="noSearchPlaceholder-subtitle noResults">
                                <FormattedMessage
                                    id="general.noResultsPlaceholderSubtitle"
                                    values={{ term: copyTerm }}
                                />
                            </div>
                        </div>
                    )}
                {companies.isGettingCompanies && (
                    <div
                        className="searchResultsSpinner"
                        style={{ marginTop: 32 }}
                    >
                        <Spinner />
                    </div>
                )}
                {companies &&
                    companies.records &&
                    !companies.isGettingCompanies &&
                    companies.records.map((item: any) => {
                        return (
                            <CompanyCard
                                item={item}
                                onSelect={() =>
                                    props.onSelect(item.fiscal_code)
                                }
                            />
                        );
                    })}
            </div>
        </div>
    );
};

export default SearchCompaniesComponent;
